import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'circle-chevron-up', 'CircleChevronUp', [["path",{"d":"M9 13l3 -3l3 3"}],["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"}]]);